import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { useObserver } from 'mobx-react-lite'
import { useAssetList } from 'pages/SEO/BlackFriday/hooks/useAssetList'
import React, { createRef } from 'react'
import { useBlackFridayStore } from 'store/context'
import styled from 'styled-components'
import { StyledScrollDownButton } from 'uiComponents/atoms/ScrollDownIcon/ScrollDownIcon'
import {
  complementaryColor,
  primaryColor,
  saleAlternativeColor,
} from 'uiComponents/constants/colors'
import { fsXXXXL, fwBold } from 'uiComponents/constants/typography'
import ColorTeaser from 'uiComponents/molecules/ColorTeaser/ColorTeaser'
import AssetGrid from 'uiComponents/organisms/AssetGrid/AssetGrid'
import DocumentHead from './components/DocumentHead'
import GenderSwitch from './components/GenderSwitch/'
import SeoText from './components/SeoText'

const TitleContainer = styled.div`
  text-align: center;
  font-size: ${fsXXXXL}px;
  line-height: 1.3;
  color: ${complementaryColor};
  ${fwBold};
  margin: auto;
`
const Highlight = styled.div`
  color: ${saleAlternativeColor};
`

const GridContainer = styled.div`
  background-color: ${primaryColor};
  line-height: 0.9;
`

const StyledColorTeaser = styled(ColorTeaser)`
  ${StyledScrollDownButton} {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
  }
`

export const isBlackFriday = () => {
  const today = new Date()
  const blackFriday = new Date('2021-11-26')

  return (
    blackFriday.getDate() === today.getDate() &&
    blackFriday.getMonth() === today.getMonth() &&
    blackFriday.getFullYear() === today.getFullYear()
  )
}

const BlackFriday: React.FunctionComponent = () => {
  const blackFridayStore = useBlackFridayStore()
  const { placeholders } = useObserver(() => blackFridayStore)
  const contentRef = createRef<HTMLDivElement>()
  const assetList = useAssetList()
  const { path, search } = useTrackingPageUrl()

  return (
    <div>
      <PageTrackingContextProvider
        path={path}
        search={search}
        type={TrackingPageTypeWithoutId.Other}
      >
        <DocumentHead
          blackFridayTitle={
            isBlackFriday()
              ? placeholders['{{BF-LP-TITLE-SALE}}'] ??
                placeholders['{{BF-LP-TITLE}}']
              : placeholders['{{BF-LP-TITLE}}']
          }
          blackFridayMeta={
            isBlackFriday()
              ? placeholders['{{BF-LP-META-SALE}}'] ??
                placeholders['{{BF-LP-META}}']
              : placeholders['{{BF-LP-META}}']
          }
        />
        <StyledColorTeaser
          color={primaryColor}
          targetScrollElementRef={contentRef}
        >
          <TitleContainer>
            <div
              dangerouslySetInnerHTML={{
                __html: placeholders['{{BF-LP-HEROTITLE}}'],
              }}
            />
            {placeholders['{{BF-LP-HERODESCRIPTION}}'] && (
              <Highlight
                dangerouslySetInnerHTML={{
                  __html: placeholders['{{BF-LP-HERODESCRIPTION}}'],
                }}
              />
            )}
          </TitleContainer>
          <GenderSwitch />
        </StyledColorTeaser>
        <GridContainer ref={contentRef}>
          <AssetGrid assetList={assetList} />
        </GridContainer>
        <SeoText />
      </PageTrackingContextProvider>
    </div>
  )
}

export default BlackFriday
